export const useNetwork = (): 'mainnet' | 'testnet' | 'devnet' => {
  return 'mainnet';
};
